/** Lowercased and stripped of accents, so `eclair` finds `Éclair` and `ÉCLAIR` alike. */
export const foldForSearch = (text: string): string => text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

export const matchesSearch = (text: string, search: string): boolean =>
  foldForSearch(text).includes(foldForSearch(search));
